export function getLoginUrlWithCurrentPageRedirect(): string {
    const redirect = `${window.location.pathname}${window.location.search}`;

    if (redirect === '/login' || redirect === '/') {
        return '/login';
    }

    return `/login?redirect=${encodeURIComponent(redirect)}`;
}
